var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 18,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "Warning_svg__a",
  width: 20,
  height: 18,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M17.061 17.008c1.54 0 2.5-1.67 1.73-3L11.261.998c-.77-1.33-2.69-1.33-3.46 0l-7.53 13.01c-.77 1.33.19 3 1.73 3zm-7.53-7c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1m-1 2v2h2v-2z",
  clipRule: "evenodd"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Warning_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#888",
  d: "M-2.469-3.496h24v24h-24z"
}))));
export default SvgWarning;